var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"whit-bg"},[_c('span',{directives:[{name:"active-touch",rawName:"v-active-touch"}],staticClass:"primary-btn payment-btn",on:{"click":_vm.handlePayment}},[(_vm.iconPath)?_c('img',{attrs:{"src":_vm.iconPath,"alt":`${_vm.selectedMethod} icon`}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.buttonText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }